import { CreateAddressInput } from "../../common/generated-types";

type AddressLikeInput = Partial<CreateAddressInput> & {
    country?: { code?: string };
};

export function toCreateAddressInput(value: AddressLikeInput | null | undefined): CreateAddressInput {
    if (!value) {
        return {
            city: "",
            company: "",
            countryCode: "",
            streetLine1: "",
        };
    }

    const v = value;

    const countryCode =
        typeof v.countryCode === "string"
            ? v.countryCode
            : v.country?.code ?? "";

    return {
        city: v.city ?? "",
        company: v.company ?? "",
        countryCode,
        defaultBillingAddress: v.defaultBillingAddress,
        defaultShippingAddress: v.defaultShippingAddress,
        fullName: v.fullName ?? "",
        phoneNumber: v.phoneNumber ?? "",
        postalCode: v.postalCode ?? "",
        province: v.province ?? "",
        streetLine1: v.streetLine1 ?? "",
        streetLine2: v.streetLine2 ?? "",
    };
}
